import { render, staticRenderFns } from "./WindowManagerWindow.vue?vue&type=template&id=23e00f14&scoped=true&"
import script from "./WindowManagerWindow.vue?vue&type=script&lang=js&"
export * from "./WindowManagerWindow.vue?vue&type=script&lang=js&"
import style0 from "./WindowManagerWindow.vue?vue&type=style&index=0&id=23e00f14&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23e00f14",
  null
  
)

export default component.exports